import { render, staticRenderFns } from "./ind-input.vue?vue&type=template&id=35878a3a&"
import script from "./ind-input.vue?vue&type=script&lang=js&"
export * from "./ind-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports